import React, { Fragment } from "react";
import { Rooms } from "..";
import Calender from "../calender";
import GuestCount from "../guestcount";
import RateplanComp from "./rateplanComp";
import { useLocation } from "react-router-dom";
import { Count, CustomContainer, Title } from "../../commonElements";
import { Abtest } from "../../mixpanel";
import { useSelector } from "react-redux";
import { roomSelector } from "../rooms/roomSlice";

function SectionA({ setQueryDetails, queryDetails }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { roomCounts } = useSelector(roomSelector);

  return (
    <CustomContainer className="bg-background  lg:bg-white pt-[32px] pb-[8px] lg:top-[58px] lg:sticky">
      <Count count={"1"} />
      <Abtest
       
        VariantA={
          <>
            <Title
              variant={"h1"}
              className={`text-accent-text`}
              content={"Book your room"}
            />
            <p className="text-text-secondary text-[13px] flex justify-center mt-[4px] font-light uppercase mb-[32px]">
              REQUIRED
            </p>
          </>
        }
        VariantB={<div className=" uppercase mb-[32px] text-accent-text text-center leading-[15.6px] text-[13px] font-light" >Check availability</div>}
      />

      <Calender queryDetails={queryDetails} />
      {
        roomCounts.map((room, index) => (
          <GuestCount
            room={room}
            queryDetails={queryDetails}
            setQueryDetails={setQueryDetails}
            key={index}
            index={index}
            showRemoveButton={roomCounts.length > 1}
          />
        ))
      }
      <Abtest
        VariantA={
          <Rooms
            isDateProvideInQuery={
              searchParams.get("datein") && searchParams.get("dateout")
                ? true
                : false
            }
            queryDetails={queryDetails}
            isdefaultRoomSelection={true}
          />
        }
        VariantB={
          <>
            <RateplanComp />
            <Rooms
              isDateProvideInQuery={
                searchParams.get("datein") && searchParams.get("dateout")
                  ? true
                  : false
              }
              queryDetails={queryDetails}
              isdefaultRoomSelection={false}
            />
          </>
        }
      />
    </CustomContainer>
  );
}

export default SectionA;
